'use strict';
import React from 'react';
import { Link } from 'react-router-dom';
import SideMenu from '../components/sideMenu';
import NavBar from '../components/navBar';
import Loading from '../components/loading';
import menuAction from '../actions/menuAction';
import filterAction from '../actions/filterAction';
import filterStore from '../stores/filterStore';
import permissionAction from '../actions/permissionAction';
import permissionStore from '../stores/permissionStore';
import PermissionModal from './permissionComponents/permissionModal';


class PermissionSetting extends React.Component {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
        this.onFilterChange = this.onFilterChange.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.shouldModalClose = this.shouldModalClose.bind(this);
        this.callBack = this.callBack.bind(this);
        this.state = {
            staffs: filterStore.getState().staffs,
            processingFilter: filterStore.getState().processing,
            iniLoadStaff: filterStore.getState().iniLoadStaff,

            processing: permissionStore.getState().processing,
            isSucceed: permissionStore.getState().isSucceed,
            permission: permissionStore.getState().permission,

            staffIds: [],
            title: "",
            index: "",
            permissionId: "",
            modalClose: false,
        };
    }

    componentDidMount() {
        permissionStore.listen(this.onChange);
        filterStore.listen(this.onFilterChange);
        menuAction.pageNumber(14);
        if (!this.state.processing) {
            permissionAction.processing(true);
            permissionAction.getPermission();
        }
        if (!this.state.processingFilter && !this.state.iniLoadStaff) {
            filterAction.processing(true);
            filterAction.getEmployee();
        }
    }

    componentWillUnmount() {
        permissionStore.unlisten(this.onChange);
        filterStore.unlisten(this.onFilterChange);
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.state.isSucceed && prevState.isSucceed != this.state.isSucceed) {
            this.setState({ modalClose: true });
        }
    }

    shouldModalClose(data) {
        this.setState({ modalClose: data });
    }

    onFilterChange(state) {
        this.setState({
            staffs: state.staffs,
            processingFilter: state.processing,
            iniLoadStaff: state.iniLoadStaff,
        });
    }
    onChange(state) {
        this.setState({
            processing: state.processing,
            isSucceed: state.isSucceed,
            permission: state.permission
        });
    }
    handleClick(e) {
        let permissionId = e.target.getAttribute('data-id');
        let index = parseInt(e.target.getAttribute('data-index'));
        let staffIds = this.state.permission[index].staffIds;
        let title = this.state.permission[index].title;
        this.setState({
            permissionId: permissionId,
            staffIds: staffIds,
            index: index,
            title: title,
            modalClose: true
        });
    }
    handleSubmit(e) {
        if (this.state.processing) return;

        permissionAction.processing(true);
        permissionAction.updatePermission(this.state.permission);
    }
    callBack(staffIds) {
        let permission = this.state.permission;
        if (permission[this.state.index].permissionId == this.state.permissionId) {
            permission[this.state.index].staffIds = staffIds;
        }
        permissionAction.permission(permission);
        this.setState({ modalClose: false });
    }
    renderList(staffIds) {
        return staffIds.map((staff, index) => {
            return (
                <div className="pm-st" key={index}>
                    {staff.userName}
                </div>
            );
        });
    }
    renderPermission() {
        return this.state.permission.map((perm, index) => {
            return (
                <div className="pm-wp" key={index}>
                    <div className="pm-tt-wp">
                        <div className="pm-tt">
                            {perm.title}
                        </div>
                        <div className="pm-ct">
                            {perm.description}
                        </div>
                        <button className="btn btn-default btn-sm pm-edit"
                            data-id={perm.permissionId} data-index={index} onClick={this.handleClick}
                        >
                            Edit
                        </button>
                    </div>
                    <div className="pm-st-wp">
                        <div className="pm-st-tt">Users granted permission:</div>
                        {this.renderList(perm.staffIds)}
                    </div>

                </div>
            )
        });
    }
    render() {
        let modal = '';
        if (this.state.modalClose) {
            modal = (
                <PermissionModal
                    modalClose={this.state.modalClose}
                    shouldModalClose={this.shouldModalClose}
                    staffIds={this.state.staffIds}
                    staffs={this.state.staffs}
                    title={this.state.title}
                    callBack={this.callBack}
                />
            );
        }
        return (
            <div className="container-fluid content">
                <div className="row">
                    <NavBar {...this.props} />
                    <SideMenu {...this.props} />
                    <div className=" col-md-10  col-sm-8 us-form">
                        <h4><b>Permission Management</b></h4>

                        {this.renderPermission()}
                        <div className="pm-btn-group">
                            <button className="btn btn-danger" onClick={this.handleSubmit}>Save</button>
                        </div>
                    </div>
                </div>
                {modal}
                <Loading processing={this.state.processing || this.state.processingFilter} />
            </div>
        );
    }
}
export default PermissionSetting;


// WEBPACK FOOTER //
// ./app/setComponents/permissionSetting.js